module.exports = __webpack_public_path__ + "img/Jump Casting111.7e6c88be.jpg";